import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'
import { Observable, of, ReplaySubject } from 'rxjs'
import { tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class LoadScriptsService {
  private _loadedLibraries: { [url: string]: ReplaySubject<any> } = {}

  constructor(@Inject(DOCUMENT) private readonly document: any) { console.info(`## ${this.constructor.name}`) }

  /**
   * Loads the external library on demand
   * @param url
   */
  loadScript(url: string): Observable<any> {
    /** If the script has already been loaded, returns what already exists **/
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable()
    }

    this._loadedLibraries[url] = new ReplaySubject()

    const script = this.document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = url
    script.onload = () => {
      this._loadedLibraries[url].next(true)
      this._loadedLibraries[url].complete()
    }

    this.document.body.appendChild(script)

    return this._loadedLibraries[url].asObservable().pipe(tap(() => null/*!env.production && console.log(`LOADED SCRIPT ${url}`)*/));
  }

  /**
   * Loads the external CSS on demand
   * @param url
   */
  loadStyle(url: string): Observable<any> {
    /** If the style has already been loaded, returns what already exists **/
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable()
    }

    this._loadedLibraries[url] = new ReplaySubject()

    const head = this.document.querySelector('head')
    const link = this.document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.async = true
    link.href = url
    link.onload = () => {
      this._loadedLibraries[url].next(true)
      this._loadedLibraries[url].complete()
    }

    // this.document.body.appendChild(link)
    head.appendChild(link)

    return this._loadedLibraries[url].asObservable() // .pipe(tap(() => !env.production && console.log(`LOADED STYLE ${url}`)))
    // return of(true)
  }

  /**
   * Remove a cached style and its DOM element
   * Used when switching programs to reload fresh CSS
   * @param url
   */
  removeStyle(url: string): void {
    // Remove from cache
    if (this._loadedLibraries[url]) {
      delete this._loadedLibraries[url]
    }

    // Remove from DOM
    const head = this.document.querySelector('head')
    if (head) {
      const link = head.querySelector(`link[href="${url}"]`)
      if (link) link.remove()
    }
  }
}
